/** Free Google Fonts the settings panel offers (name -> stylesheet URL). */
export const FREE_GOOGLE_FONTS: Record<string, string> = {
  Lato: 'https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700&display=swap',
  Inter: 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap',
  Poppins: 'https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap',
  Roboto: 'https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap',
  'Open Sans': 'https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700&display=swap',
  Montserrat: 'https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap',
  Nunito: 'https://fonts.googleapis.com/css2?family=Nunito:wght@300;400;600;700&display=swap',
  Cairo: 'https://fonts.googleapis.com/css2?family=Cairo:wght@300;400;600;700&display=swap',
  Tajawal: 'https://fonts.googleapis.com/css2?family=Tajawal:wght@300;400;500;700&display=swap',
};

export const BODY_FONT_OPTIONS = Object.keys(FREE_GOOGLE_FONTS).filter((name) => name !== 'Cairo' && name !== 'Tajawal');
export const RTL_FONT_OPTIONS = ['Cairo', 'Tajawal', 'Inter', 'Poppins'] as const;
export const FONT_BASE_PRESETS = ['87.5', '93.75', '100', '106.25', '112.5'] as const;
export const RADIUS_PRESETS = ['0', '4', '6', '8', '12', '16', '9999'] as const;

export const FONT_LINK_ID = 'theme-font-body';

/** The stylesheet that loads a font: the built-in one, or Google's generic URL for any other family. */
export function resolveFontUrl(fontName: string): string {
  const name = fontName.trim();
  if (FREE_GOOGLE_FONTS[name]) {
    return FREE_GOOGLE_FONTS[name];
  }
  const family = encodeURIComponent(name).replace(/%20/g, '+');
  return `https://fonts.googleapis.com/css2?family=${family}:wght@300;400;500;600;700&display=swap`;
}

/** The CSS font-family value for a font name. */
export function fontFamilyStack(fontName: string): string {
  const name = fontName.trim() || 'Lato';
  return `"${name}", "Noto Sans Arabic", ui-sans-serif, system-ui, sans-serif`;
}
